module.exports = __webpack_public_path__ + "static/media/contratocontraventa.4d5746dc.svg";